import React, { useState, useEffect } from "react";
import mergedcharges_step1 from "../../assets/MergedChargesFlow/first_image.png";
import mergedcharges_step2 from "../../assets/MergedChargesFlow/step-1.png";
import mergedcharges_step3 from "../../assets/MergedChargesFlow/step-2.png";
import mergedcharges_step4 from "../../assets/MergedChargesFlow/step-3.png";
import mergedcharges_step5 from "../../assets/MergedChargesFlow/step-4.png";
import mergedcharges_step6 from "../../assets/MergedChargesFlow/step-5.png";
import mergedcharges_step7 from "../../assets/MergedChargesFlow/step-6.png";
import mergedcharges_step8 from "../../assets/MergedChargesFlow/step-7.png";
import "../../styles/MergedChargesTooltip.css";
import ImagePreviewModal from "./ImagePreviewModal";

const slides = [
  {
    title: "Merged Charges Flow",
    desc: "Charges are consolidated based on SAP code. Line items can be combined or uncombined to generate a single invoice or separate invoices.",
    img: mergedcharges_step1,
  },
  {
    title: "Charges Grouped by SAP Code",
    desc: "Charges are consolidated vendor-wise based on SAP Code across multiple jobs. User selections automatically determine how charges are grouped and merged.",
    img: mergedcharges_step2,
  },
  {
    title: "Single Invoice Creation",
    desc: "One job has a combined line item and another has multiple uncombined line items. Upon selection and submission, a single consolidated invoice is generated.",
    img: mergedcharges_step3,
  },
  {
    title: "Review & Submit Invoice",
    desc: "Before submission, the user reviews the final invoice details including remarks, billing nature, supply period, and backdated date. The system displays a preview of the final consolidated sales data for verification.",
    img: mergedcharges_step4,
  },
  {
    title: "Separate Invoice Creation",
    desc: "Line-item wise selection of combined and uncombined charges enables generation of separate invoices across multiple jobs.",
    img: mergedcharges_step5,
  },
  {
    title: "Enter Separate Invoice Details",
    desc: "For each selected charge, users can enter invoice-specific details such as remarks, billing nature, supply period, and backdated date. Global fields can also be applied across all line items for faster processing.",
    img: mergedcharges_step6,
  },
  {
    title: "Review & Submit Separate Invoices",
    desc: "Before final submission, users can review all generated separate invoices along with their charge details and confirm the entries to complete invoice creation.",
    img: mergedcharges_step7,
  },
  {
    title: "Invoice Generation Completed",
    desc: "Single or separate invoices have been created successfully based on combined or uncombined charges.",
    img: mergedcharges_step8
  }
];

const MergedChargesTooltip = () => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  useEffect(() => {
    if (paused || isPreviewOpen) return;

    const timer = setInterval(() => {
      nextSlide();
    }, 2500);

    return () => clearInterval(timer);
  }, [paused, isPreviewOpen]);

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % slides.length);
  };

  return (
    <>
      <div className="tooltip-carousel">
        <button className="carousel-arrow left" onClick={prevSlide}>‹</button>
        <button className="carousel-arrow right" onClick={nextSlide}>›</button>

        <div
          className="carousel-track"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {slides.map((slide, i) => (
            <div
              key={i}
              className={`carousel-slide ${i === index ? "carousel-slide-active" : ""
                }`}
            >
              <img
                src={slide.img}
                alt={slide.title}
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
                onClick={() => setIsPreviewOpen(true)}
              />
              <h6>{slide.title}</h6>
              <p>{slide.desc}</p>
            </div>
          ))}
        </div>

        <div className="carousel-dots">
          {slides.map((_, i) => (
            <span
              key={i}
              className={i === index ? "dot active" : "dot"}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      </div>

      {isPreviewOpen && (
        <ImagePreviewModal
          data={slides[index]}
          onClose={() => setIsPreviewOpen(false)}
          onPrev={prevSlide}
          onNext={nextSlide}
        />
      )}
    </>
  );
};

export default MergedChargesTooltip;
